import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import {Button} from '../../../components'
import {Container, Title, Subtitle} from '../../flow'
import Costs from '../containers/costs'

const styles = (theme) => ({
  container: {maxWidth: 328, margin: '0 auto'},
  title: {marginBottom: 20},
  button: {marginTop: 50},
})

class DoneStep extends React.Component {

  static displayName = 'DoneStep.component'

  componentDidMount() {
    this.props.updateUrl()
  }

  render() {
    const {classes} = this.props
    return (
      <Container className={classes.container}>
        <Costs/>
        <Title className={classes.title}>¡Listo! Tu retiro ha sido programado.</Title>
        <Subtitle>Hemos enviado una confirmación a tu dirección de email.</Subtitle>
        <div style={{width: '100%', textAlign: 'center'}}>
          <img src={'/assets/stepDoneCar.png'} width={'100%'} height={60} alt={'moving car'}/>
        </div>
        <Button
          variant={'primary'}
          fullWidth={true}
          className={classes.button}
          onClick={this.props.continue}
        >
          Continuar
        </Button>
      </Container>
    )
  }

  static propTypes = {
    continue: PropTypes.func.isRequired,
    updateUrl: PropTypes.func.isRequired,
  }
}

export default withStyles(styles, {withTheme: true})(DoneStep)



// WEBPACK FOOTER //
// ./src/sections/depositV2/components/done.step.jsx